import { loadStripe } from '@stripe/stripe-js'
import { STRIPE_KEY } from 'env'

/**
 * Safely loads Stripe.js with error handling.
 *
 * The raw loadStripe() call can throw unhandled promise rejections when:
 * - Web crawlers/bots hit the page (they can't load external scripts)
 * - Network issues prevent script loading
 * - Script is blocked by browser extensions or CSP
 *
 * This wrapper catches those errors and returns null instead of throwing,
 * allowing the app to gracefully degrade.
 *
 * @returns {Promise<Stripe|null>} Stripe instance or null if loading failed
 */
const stripePromise = loadStripe(STRIPE_KEY).catch(error => {
  // Log for debugging but don't throw - prevents UnhandledPromiseRejection
  // This commonly happens with bots/crawlers that can't load external scripts
  console.warn('Failed to load Stripe.js:', error?.message || error)
  return null
})

export default stripePromise
